<template>
  <div class="animated fadeIn">
    <Alerts ref="alert"/>
    <Forms ref="frmGroup"
      :title="this.$lang.Coordinator.TitleForm"
      :showHelp="true"
      :showClearButton="true"
      :showSaveButton="true"
      v-on:Clear="onClear"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-4">
          <label for="txtGroup"><small class="text-danger">*</small> {{$lang.Coordinator.LabelBranch}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.secaoRHID.value" :options="form.secaoRHID.options">
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtGroup"><small class="text-danger">*</small> {{$lang.Coordinator.LabeCoordinator}} (conta):</label>
          <div class="input-group">
            <b-form-select v-model="form.contaID.value" :options="form.contaID.options">
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtGroup"><small class="text-danger">*</small> {{$lang.Coordinator.LabeCoordinatorEmail}} (conta):</label>
          <div class="input-group">
            <b-form-input type="email"
                          :placeholder="$lang.Accounts.PlaceholderEnterEmail"
                          v-model="form.email.value"
                          :maxlength="form.email.maxlength"
                          :required="form.email.required"
                          :state="form.email.state"
                          autocomplete="false"
                          disabled="disabled"></b-form-input>
          </div>
        </div>
      </div>
    </Forms>
    <Tables ref="tableGrid"
            :columns="[
              $lang.Coordinator.DataTable.Branch,
              $lang.Coordinator.DataTable.Name,
              $lang.Common.DataTable.Status,
              $lang.Common.DataTable.ActionDate,
              $lang.Common.DataTable.AccountAction,
              $lang.Common.DataTable.Actions]"
            :showSearch="false"
            :showPrint="false"
            :showDownload="false"
            :showFullscreen="false"
            v-on:Load="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.secaoRH ? obj.secaoRH.nome : ''" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.conta ? obj.conta.nome : ''" />
        <TableColumn :IsStatus="true" v-on:Edit="onEdit(obj)" :status="obj.status" />
        <TableColumn :IsDatetime="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.dataAcao" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.nomeContaAcao" />
        <TableColumn :IsActionsButtons="true" v-on:Change="onChange(obj)" v-on:Delete="onDelete(obj)" :status="obj.status" />
      </tr>
    </Tables>
  </div>
</template>
<script>
import Coordinator from './coordinator.js'
export default Coordinator
</script>



// WEBPACK FOOTER //
// src/views/private/configuration/coordinator/coordinator.vue